import styled, { css } from 'styled-components';

export const MessageWrapper = styled.div`
    display: flex;
    align-items: center;
    box-shadow: 0 4px 20px 0 rgb(0 0 0 / 10%);

    ${({ type }) =>
        type === 'error' &&
        css`
            margin-top: 20px;
        `}
`;

export const IconWrapper = styled.div`
    height: 70px;
    width: 70px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${({ type }) => css`
        ${type === 'success' &&
        css`
            background-color: #29d885;
        `}

        ${type === 'error' &&
        css`
            background-color: #e44b5e;
        `}
    `}

    i {
        font-size: 46px;
        color: #fff;
    }
`;

export const TextWrapper = styled.div`
    flex: 1;
    padding: 12px;
    font-size: 14px;
`;
